import { render, staticRenderFns } from "./tabbed-nav.vue?vue&type=template&id=de046b6c&"
import script from "./tabbed-nav.vue?vue&type=script&lang=js&"
export * from "./tabbed-nav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports